import React from 'react';

// const DigitalAssetVideo: React.FC<{ element: any }> = ({ element }) => {

// console.log("The digital asset video element is", element.video_url.value)

interface VideoJSOptions {
  autoplay?: boolean | 'play' | 'muted' | 'any';
  sources: {
    src: string;
    type: string;
  }[];
}

interface VideoJSProps {
  options: VideoJSOptions;
  altText?: string;
}

const VideoJSIFrame: React.FC<VideoJSProps> = props => {
  const { options, altText } = props;

  return (
    <>
      <iframe
        title={altText || 'CMS Video'}
        src={options.sources[0].src}
        width="960"
        height="540"
        aria-label={altText || 'CMS Video'}
        allowFullScreen
      />
    </>
  );
};

export default VideoJSIFrame;
